import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { Footer } from './components/Footer';
import { useGptInit } from './hooks/useGptInit';
export function App() {
  useGptInit('Homepage');
  return <div className="min-h-screen bg-white w-full overflow-x-hidden font-['League_Gothic']" data-id="element-0">
      {/* ═══ HEADER ═══ */}
      <Header data-id="element-1" />

      {/* ═══ TOP AD BANNER ═══ */}
      <div className="w-full flex items-center justify-center" style={{
      padding: '15px 20px'
    }} data-id="element-2">
        <img src="https://cdn.magicpatterns.com/uploads/aRvEPA7nKDuo2o2MzgvBvi/Leaderboard_728x90.png" alt="Leaderboard Ad" style={{
        maxWidth: '728px',
        width: '100%',
        height: 'auto',
        display: 'block'
      }} data-id="element-3" />
      </div>

      {/* ═══ HERO SECTION ═══ */}
      <HeroSection data-id="element-4" />

      {/* ═══ FOOTER ═══ */}
      <Footer data-id="element-5" />
    </div>;
}